
const translations = {
  // Navbar
  "nav.home": "Inicio",
  "nav.destinations": "Destinos",
  "nav.bookings": "Reservas",
  "nav.testimonials": "Testimonios",
  "nav.blog": "Blog",
  "nav.prices": "Tarifas",
  "nav.contact": "Contacto",
  
  // Hero
  "hero.badge": "Servicio Premium en Fuerteventura",
  "hero.title1": "Descubre",
  "hero.title2": "Fuerteventura",
  "hero.title3": "Con Elegancia",
  "hero.description": "Experimenta el lujo de viajar por la isla con nuestro servicio exclusivo de transporte premium. Vehículos de alta gama, conductores profesionales y atención personalizada.",
  "hero.bookNow": "Reservar Ahora",
  "hero.viewDestinations": "Ver Destinos",
  
  // Destinos
  "destinations.title": "Destinos Exclusivos",
  "destinations.subtitle": "Descubre los rincones más selectos de Fuerteventura con nuestro servicio de transporte de lujo",
  "destinations.from": "Desde",
  "destinations.duration": "Duración",
  "destinations.book": "Reservar",
  
  // Reservas
  "bookings.title": "Reserve su Viaje",
  "bookings.subtitle": "Complete el formulario y confirme su reserva premium en minutos",
  "bookings.origin": "Origen",
  "bookings.destination": "Destino",
  "bookings.date": "Fecha",
  "bookings.time": "Hora",
  "bookings.passengers": "Pasajeros",
  "bookings.name": "Nombre completo",
  "bookings.email": "Correo electrónico",
  "bookings.phone": "Teléfono",
  "bookings.submit": "Confirmar Reserva",
  "bookings.selectOrigin": "Seleccione origen",
  "bookings.selectDestination": "Seleccione destino",
  
  // Testimonios
  "testimonials.title": "Opiniones de Clientes Selectos",
  "testimonials.subtitle": "Más de 5,000 viajeros distinguidos confían en nosotros",
  "testimonials.verified": "Verificado",
  
  // Servicios
  "services.title": "Servicios Premium",
  "services.subtitle": "Excelencia y distinción en cada trayecto",
  "services.vehicles": "Flota de Lujo",
  "services.vehiclesDesc": "Mercedes Clase V y E con interior de cuero, climatización premium y WiFi de alta velocidad",
  "services.drivers": "Chóferes Profesionales",
  "services.driversDesc": "Personal altamente cualificado con formación en protocolo y atención VIP",
  "services.punctuality": "Puntualidad Garantizada",
  "services.punctualityDesc": "Compromiso absoluto con su tiempo. Seguimiento GPS en tiempo real",
  "services.support": "Concierge 24/7",
  "services.supportDesc": "Servicio de asistencia personal disponible las 24 horas del día",
  
  // Precios
  "prices.title": "Tarifas Premium",
  "prices.subtitle": "Transparencia y exclusividad en cada servicio",
  "prices.popular": "Recomendado",
  "prices.book": "Reservar",
  
  // Blog
  "blog.title": "Guía de Fuerteventura",
  "blog.subtitle": "Descubra los secretos mejor guardados de la isla",
  "blog.readMore": "Leer más",
  
  // Contacto
  "contact.title": "Contacto",
  "contact.subtitle": "Estamos a su disposición",
  "contact.name": "Nombre",
  "contact.email": "Email",
  "contact.message": "Mensaje",
  "contact.send": "Enviar Mensaje",
  "contact.address": "Dirección",
  "contact.phone": "Teléfono",
  "contact.hours": "Horario",
  "contact.hoursValue": "Servicio 24/7",
  
  // Footer
  "footer.destinations": "Destinos",
  "footer.services": "Servicios",
  "footer.information": "Información",
  "footer.legal": "Legal",
  "footer.onlineBookings": "Reservas Online",
  "footer.rates": "Tarifas",
  "footer.reviews": "Opiniones",
  "footer.travelGuide": "Guía de Viaje",
  "footer.aboutUs": "Sobre Nosotros",
  "footer.faq": "Preguntas Frecuentes",
  "footer.privacy": "Política de Privacidad",
  "footer.terms": "Términos y Condiciones",
  "footer.cookies": "Política de Cookies",
  "footer.legalNotice": "Aviso Legal",
  "footer.since": "Desde 2010",
  "footer.rights": "Todos los derechos reservados."
};

export default translations;
